import { validate } from 'gerador-validador-cpf';
import { IAnswer } from '../interfaces';

export function cpf(v: string){
  v=v.replace(/\D/g,"");
  v=v.replace(/(\d{3})(\d)/,"$1.$2");
  v=v.replace(/(\d{3})(\d)/,"$1.$2");
  v=v.replace(/(\d{3})(\d)/,"$1-$2");
  return v.substring(0, 14);
}

export function rg(v: string){
  v=v.replace(/\D/g,"");
  v=v.replace(/(\d{2})(\d)/,"$1.$2");
  v=v.replace(/(\d{3})(\d)/,"$1.$2");
  v=v.replace(/(\d{3})(\d)/,"$1-$2");
  return v.substring(0, 14);
}

export function rgRne(v: string){
  const validateNumber = v.replace(/[^\w\s]/gi, ''); 
  if (Number.isNaN(Number(validateNumber))) {
    v = validateNumber.toUpperCase().replace(/^(RNE)(\w)(\d{6})(\w)$/, '$1$2$3$4');
    return v.substring(0, 14);
  } else {
    v=v.replace(/\D/g,"");
    v=v.replace(/(\d{2})(\d)/,"$1.$2");
    v=v.replace(/(\d{3})(\d)/,"$1.$2");
    v=v.replace(/(\d{3})(\d)/,"$1-$2");
    return v.substring(0, 14);
  }
}

export function onlyNumber(value: string){
  return value.replace(/\D/g,"");
}

export function cellphone(v: string){
  v=v.replace(/\D/g,"");
  v=v.replace(/^(\d\d)(\d)/g,"($1) $2");
  v=v.replace(/(\d{4})(\d{4})$/,"$1-$2");
  return v.substring(0, 15);
}

export function cep(v: string){
  v=v.replace(/D/g,"");
  v=v.replace(/^(\d{5})(\d)/,"$1-$2");
  return v.substring(0, 9);
}

export function validateCpf(strCpf: string){
  return validate(strCpf);
}

export function locationQuery() {
  return new URLSearchParams(window.location.search);
};

export function formatDate(v: string){
  if (v.match(/^\d{2}$/) !== null) {
    v = v + '/';
  } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
    v = v + '/';
  }
  return v.substring(0, 10);
}

export function objfieldNameVoucher(valuesArr: IAnswer[]) {
  const objVoucher: any = {};

  for (let i = 0; i < (valuesArr?.length || 0); i++) {
    if (!!valuesArr && valuesArr[i]) {
      const el = valuesArr[i];
      if(el?.fieldNameVoucher) {
        objVoucher[el?.fieldNameVoucher] = el?.fieldNameVoucher === 'phone' 
          ? onlyNumber(el?.answer as string) 
          : el?.answer;
      }
    }
  }

  return objVoucher;
}

export function splitList(arr: any[], n: number) {
  var chunkLength = Math.max(arr.length/n , 1);
     var chunks: any[] = [];
     for (var i = 0; i < n; i++) {
         if(chunkLength*(i+1)<=arr.length)chunks.push(arr.slice(chunkLength*i, chunkLength*(i+1)));
     }
     return chunks; 
}

export function email(email: string) {
  return email.toLowerCase();
}
